export const normal = 400;
export const light = 300;
export const semibold = 500;
export const bold = 600;

export const baseSizeInPx = 16;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/fontWeights.ts